'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var data = require('./data.js');

var get = require('./get.js');

var links = require('./links.js');

var _new = require('./new.js');

var put = require('./put.js');

var stat = require('./stat.js');

var index = require('./patch/index.js');

var ObjectAPI = function ObjectAPI(_ref) {
  var repo = _ref.repo,
      codecs = _ref.codecs,
      preload = _ref.preload;

  _classCallCheck(this, ObjectAPI);

  this.data = data.createData({
    repo: repo,
    preload: preload
  });
  this.get = get.createGet({
    repo: repo,
    preload: preload
  });
  this.links = links.createLinks({
    repo: repo,
    codecs: codecs
  });
  this.new = _new.createNew({
    repo: repo,
    preload: preload
  });
  this.put = put.createPut({
    repo: repo,
    preload: preload
  });
  this.stat = stat.createStat({
    repo: repo,
    preload: preload
  });
  this.patch = new index.ObjectPatchAPI({
    repo: repo,
    preload: preload
  });
};

exports.ObjectAPI = ObjectAPI;